import { useEffect } from 'react';
import { getHoldingsFilters } from '../../canopy-ui-components/api/filters';
import Filters from '../../canopy-ui-components/components/Filters/SimpleFilters';
import { filterOptions } from './FilterOptions';

const DEFAULT_FILTER_GROUP = 'user_asset_class';

function SimpleFilters({
    layoutState,
    setLayoutState,
    dataKey,
    filterApi,
    globalProps,
    selectedGroupBy,
    selectedGroupByFilters,
    setSelectedGroupBy,
    setSelectedGroupByFilters,
    setGroupBy,
    setGroupByFilters,
    groupBy,
    groupByFilters,
    setUserId,
    userId,
}: any) {
    const onApplyFilter = (
        filters: string[][],
        groupBy: string[] = ['select-one']
    ) => {
        setSelectedGroupBy(groupBy);
        setSelectedGroupByFilters([...filters]);
        setLayoutState((layoutState: any) => {
            return {
                ...layoutState,
                group_by:
                    groupBy[0] === 'select-one' || groupBy[0] === 'none'
                        ? ''
                        : groupBy[0],
                group_by_filters:
                    groupByFilters?.[groupBy[0]]?.length !== filters[0]?.length
                        ? escape(JSON.stringify(filters[0]))
                        : '',
            };
        });
    };

    useEffect(() => {
        (async () => {
            try {
                if (!layoutState?.user_id || layoutState?.user_id === userId) {
                    return;
                }
                const params: any =
                    layoutState?.user_id !== 'all'
                        ? {
                              parent_user_ids: layoutState?.user_id,
                          }
                        : {};
                const filters: any = await getHoldingsFilters(params);
                setGroupBy([...filterOptions]);
                setSelectedGroupBy([DEFAULT_FILTER_GROUP]);
                let transformedFilters: Record<
                    string,
                    Record<string, string>[]
                > = {};
                for (let key in filters) {
                    transformedFilters[key] = filters[key].map(
                        (value: string) => {
                            return {
                                label: value,
                                value,
                            };
                        }
                    );
                }
                setGroupByFilters(transformedFilters);
                setSelectedGroupByFilters([[...filters[DEFAULT_FILTER_GROUP]]]);
                setUserId(layoutState?.user_id);
                if (!globalProps?.qp?.group_by) {
                    setLayoutState((layoutState: any) => {
                        return {
                            ...layoutState,
                            group_by: DEFAULT_FILTER_GROUP,
                            group_by_filters: '',
                        };
                    });
                }
            } catch (e) {
                console.log(e);
            }
        })();
    }, [layoutState?.user_id]);

    return (
        <Filters
            globalProps={globalProps}
            groupByFilters={groupByFilters}
            selectedGroupByFilters={selectedGroupByFilters}
            groupBy={groupBy}
            selectedGroupBy={selectedGroupBy}
            allowMultipleFilters={false}
            defaultGroupBy={DEFAULT_FILTER_GROUP}
            selectAllFiltersOnGroupChange={true}
            onApply={onApplyFilter}></Filters>
    );
}
export default SimpleFilters;
